import _ from 'lodash';

// Shared "search modified" comparison engine for web and mobile.
// The `normalize` function is app-specific (it maps each app's search-terms
// shape into a comparable plain object); the capture/compare semantics are shared.
export function createSearchModifiedTracker(normalize) {
    let snapshot = null;

    const capture = (terms) => {
        snapshot = terms ? normalize(terms) : null;
    };

    const isModified = (terms) => (snapshot ? !_.isEqual(snapshot, normalize(terms)) : false);

    return { capture, isModified };
}
